export const PROCESS_TYPE_REF_SELECTED = 'processTypeForm/PROCESS_TYPE_REF_SELECTED';
export const ADD_BUTTON_CLICKED = 'processTypeForm/ADD_BUTTON_CLICKED';
export const SUBMIT_PROCESSTYPE_FORM = 'processTypeForm/SUBMIT_PROCESSTYPE_FORM';
